import { createContext } from "react";

import { TOUR_IDS } from "./TourContext.constants";

export type TourContextType = {
  ids: {
    platformSelect: string;
    organizationSelect: string;
    favorites: string;
    features: string;
    onboarding: string;
  };
  isTourInProgress: boolean;
};

export const TourContext = createContext<TourContextType>({
  ids: TOUR_IDS,
  isTourInProgress: false,
});
